import { AlertOctagonIcon } from './AlertOctagonIcon';

/**
 * author: Google
 * id 9BC1A338-CD03-4D39-BE46-E9DE5EE51A2F
 * name alert-octagon
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alert-octagon.svg
 * tags
 * - Alert / Error 
 */
export const StopAlertIcon = AlertOctagonIcon;
export default StopAlertIcon